import { ICellRendererParams } from "ag-grid-community";
import clsx from "clsx";
import React, { useMemo } from "react";
import ButtonGroup from "../../ButtonGroup/ButtonGroup";
import { IButton } from "../../Button/Button";

const CellWithButtonsRenderer: React.FC<{
  params: ICellRendererParams;
  buttons: Array<IButton>;
}> = ({ buttons }) => {
  const finalButtons = useMemo(() => {
    if (buttons?.length) {
      return buttons?.map?.((button: any) => ({
        ...button,
        animate: false,
        // classes: "grid-button"
      }));
    }

    return [];
  }, [buttons]);
  return (
    <div
      className={clsx([
        "shrink-0",
        "flex",
        "items-center",
        "h-full",
        "w-full",
        "justify-end",
      ])}
      onClick={(e: any) => {
        e?.stopPropagation?.();
      }}
    >
      <ButtonGroup buttons={finalButtons} gap={1} align="left" />
    </div>
  );
};

export default React.memo(CellWithButtonsRenderer);
